<script>
    export let playground;
</script>

<div>
    {#if playground && playground.rating}
    <p><span class="rating">&#9733; {playground.rating.toFixed(1)}</span> <span class="number-of-ratings">({playground.numberOfRatings})</span></p>
    {/if}
</div>

<style>
    p {
        margin: 0 !important;
    }

    span.rating {
        color: orange;
    }

    span.number-of-ratings {
        color: silver;
    }
</style>
